import { Position, Size } from 'types';

export const calculateDistance = (from: Position, to: Position) =>
  Math.sqrt(
    ((from.x - to.x) * (from.x - to.x)) +
    ((from.y - to.y) * (from.y - to.y)),
  );

export const centerPosition = (position: Position, size: Size): Position => ({
  x: position.x + (size.width / 2),
  y: position.y + (size.height / 2),
});

export const intersects = (
  mother: Position,
  motherSize: Size,
  father: Position,
  fatherSize: Size,
  tolerance: 'half' | 'touch' = 'half',
): boolean => {
  const l = mother.x;
  const t = mother.y;
  const r = l + motherSize.width;
  const b = t + motherSize.height;

  const width = fatherSize.width;
  const height = fatherSize.height;
  const x1 = father.x;
  const x2 = x1 + width;
  const y1 = father.y;
  const y2 = y1 + height;

  if (tolerance === 'touch') {
    return (
      (y1 >= t && y1 <= b) || // Top edge touching
      (y2 >= t && y2 <= b) || // Bottom edge touching
      (y1 < t && y2 > b) // Surrounded vertically
    ) && (
      (x1 >= l && x1 <= r) || // Left edge touching
      (x2 >= l && x2 <= r) || // Right edge touching
      (x1 < l && x2 > r) // Surrounded horizontally
    );
  }

  return (l < x1 + (width / 2) // right half
    && x2 - (width / 2) < r // left half
    && t < y1 + (height / 2) // bottom half
    && y2 - (height / 2) < b); // top half
};
